<template>
  <div class="search-user">
    <div class="el-search vue-top-padding radius">
      <div class="el-left">
        <el-button
          v-if="uid == '8fac433aa2ead2083b63da6d60088bd5'"
          size="small"
          icon="el-icon-printer"
          @click="exportOrder"
          >{{ $t("common.export") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-hasPerm="['sys:user:insert']"
          icon="el-icon-plus"
          hidden
          @click="addUser"
          >{{ $t("common.add") }}</el-button
        >
      </div>
      <div class="el-right">
        <el-form
          ref="user"
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item prop="userName" style="margin-bottom: 0">
            <el-input v-model="search.userName" :placeholder="$t('searchUser.userName')"></el-input>
          </el-form-item>
          <el-form-item prop="nickName" style="margin-bottom: 0">
            <el-input v-model="search.nickName" :placeholder="$t('searchUser.nickName')"></el-input>
          </el-form-item>
          <el-form-item prop="timeRange" style="margin-bottom: 0">
            <el-date-picker
              v-model="timeRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('user.SearchUser.191885-0')"
              :end-placeholder="$t('user.SearchUser.191885-1')"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t("common.search") }}</el-button>
            <el-button @click="resetSearch('user')" icon="el-icon-refresh">{{ $t("common.reset") }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SearchUser",
    props: {
      search: Object,
      uid: String
    },
    data() {
      return {
        timeRange: null
      };
    },
    watch: {
      timeRange(val) {
        if (val && val.length === 2) {
          this.search.startTime = val[0];
          this.search.endTime = val[1];
        } else {
          this.search.startTime = null;
          this.search.endTime = null;
        }
      }
    },
    methods: {
      addUser() {
        this.$emit("addUser");
      },
      configPaypal() {
        this.$emit("configPaypal");
      },
      configCashu() {
        this.$emit("configCashu");
      },
      onSubmit() {
        this.$emit("onSubmit", this.search);
      },
      resetSearch(formName) {
        this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
        this.$toolUtil.clearForm(this.search);
        this.$emit("resetSearch", this.search);
      },
      exportOrder() {
        this.$confirm(this.$t("searchUser.export"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api.download(this.$url.User.export, this.search);
          })
          .catch(err => {
            if (err.msg) {
              this.$message.error(err.msg);
            }
          });
      }
    }
  };
</script>

<style scoped></style>
